"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.modal {\n  text-align: start;\n  z-index: 1; }\n  .modal.bx--modal .bx--text-input {\n    background: #f4f4f4; }\n  .modal .bx--modal-container {\n    width: 374px;\n    background: white; }\n    .modal .bx--modal-container .bx--modal-header {\n      display: none; }\n    .modal .bx--modal-container .bx--modal-content {\n      padding: 1rem;\n      margin-bottom: 0; }\n      .modal .bx--modal-container .bx--modal-content p {\n        margin-bottom: 1rem; }\n      .modal .bx--modal-container .bx--modal-content p.title {\n        font-size: 20px;\n        line-height: 1.3;\n        color: #000000; }\n    .modal .bx--modal-container .bx--modal-footer {\n      height: 48px; }\n      .modal .bx--modal-container .bx--modal-footer .bx--btn {\n        height: 48px;\n        padding: 1rem;\n        box-shadow: none;\n        border: 0; }\n        .modal .bx--modal-container .bx--modal-footer .bx--btn.bx--btn--secondary {\n          background: #e41b13; }\n          .modal .bx--modal-container .bx--modal-footer .bx--btn.bx--btn--secondary:hover {\n            background: #99100a; }\n        .modal .bx--modal-container .bx--modal-footer .bx--btn.bx--btn--primary:hover {\n          background: #4c4c4c; }\n\n@media (max-width: 671px) {\n  .modal .bx--modal-container {\n    position: static;\n    max-width: 84%;\n    height: auto;\n    max-height: 90%; } }\n";
  const fileName = "Modal_Modal";
  const element = document.querySelector("style[data-sass-component='Modal_Modal']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Modal = props => {
  const link = props.link ? /*#__PURE__*/_react.default.createElement("p", null, props.link) : null;
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Modal, {
    open: true,
    className: 'modal',
    primaryButtonText: props.confirmLabel,
    secondaryButtonText: props.cancelLabel,
    onRequestSubmit: props.onConfirm,
    onRequestClose: props.onCancel,
    onClose: () => console.log('close'),
    passiveModal: props.passiveModal
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: 'title'
  }, props.title), /*#__PURE__*/_react.default.createElement("p", {
    className: 'lead'
  }, props.lead), link, props.formElement);
};
const validateFunctionalComponent = (props, currentPropName, allowedComponentNames) => {
  const prop = props[currentPropName];
  if (!prop) {
    return;
  }
  if (prop && !allowedComponentNames.includes(prop.type.name)) {
    return new Error('Allowed components: ' + allowedComponentNames.join(', '));
  }
};
Modal.propTypes = {
  title: _propTypes.default.string.isRequired,
  lead: _propTypes.default.string.isRequired,
  confirmLabel: _propTypes.default.string,
  cancelLabel: _propTypes.default.string,
  onConfirm: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  passiveModal: _propTypes.default.bool,
  link: function (props, propName) {
    return validateFunctionalComponent(props, propName, ['Link']);
  },
  formElement: function (props, propName) {
    return validateFunctionalComponent(props, propName, ['TextInput', 'DateInput', 'Dropdown']);
  }
};
var _default = exports.default = Modal;